module.exports = __webpack_public_path__ + "static/media/13.bc7842e9.jpg";